/** Next.js basePath for Academy (matches next.config `basePath`). */
export const ACADEMY_BASE_PATH =
  (typeof process !== 'undefined' && process.env.NEXT_PUBLIC_BASE_PATH) || '/academy';

/**
 * Relative URL path for an Academy route (includes basePath), e.g. `/academy/catalog`.
 */
export function academyPath(path: string): string {
  const base = ACADEMY_BASE_PATH.endsWith('/') ? ACADEMY_BASE_PATH.slice(0, -1) : ACADEMY_BASE_PATH;
  if (!path || path === '/') {
    return base || '/';
  }
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}

/** Course or standalone content URL segment from CMS `url` (leading slash). */
export function coursePublicPath(courseUrl: string | undefined, isStandalone?: boolean): string {
  const slug = (courseUrl || '').replace(/^\//, '');
  if (isStandalone) {
    return academyPath(`/content/${slug}`);
  }
  return academyPath(`/courses/${slug}`);
}

export function lessonPublicPath(
  courseSlug: string,
  lessonUrl: string | undefined,
  opts?: { learningPathSlug?: string; isStandalone?: boolean }
): string {
  const lessonSeg = (lessonUrl || '').replace(/^\//, '');
  if (opts?.learningPathSlug) {
    return academyPath(`/learning-paths/${opts.learningPathSlug}/${courseSlug}/${lessonSeg}`);
  }
  if (opts?.isStandalone) {
    return academyPath(`/content/${courseSlug}`);
  }
  return academyPath(`/courses/${courseSlug}/${lessonSeg}`);
}
